import { authenticatedFetch } from "@/api/session";
export type RiskLevel =
  | "HEALTHY"
  | "WATCH"
  | "AT_RISK"
  | "CRITICAL";

export type RecommendationPriority =
  | "LOW"
  | "MEDIUM"
  | "HIGH"
  | "CRITICAL";

export type ScoreContribution = {
  source: string;
  points: number;
  weight: number;
  weighted_points: number;
  explanation: string;
};

export type IntelligenceRecommendation = {
  priority: RecommendationPriority;
  title: string;
  action: string;
  reason: string;
};

export type MemberRiskAssessment = {
  score: number;
  level: RiskLevel;
  confidence: number;
  generated_at: string;
  engine_version: string;
  explanation: string[];
  contributions: ScoreContribution[];
  recommendations: IntelligenceRecommendation[];
};

const API_BASE_URL = "http://localhost:8000";

function getAuthHeaders() {
  const token = localStorage.getItem("access_token");

  return {
    Authorization: `Bearer ${token}`,
  };
}

export async function getMemberRiskAssessment(
  churchId: string,
  memberId: string
): Promise<MemberRiskAssessment> {
  const response = await authenticatedFetch(
    `${API_BASE_URL}/intelligence/churches/${churchId}/members/${memberId}/risk`,
    {
      headers: getAuthHeaders(),
    }
  );

  if (!response.ok) {
    throw new Error("Failed to load member intelligence");
  }

  return response.json();
}

export type RiskMember = {
  member_id: string;
  full_name: string;
  score: number;
  level: RiskLevel;
};

export type IntelligenceDashboard = {
  church_health: number;
  total_assessments: number;
  critical_members: number;
  at_risk_members: number;
  members: RiskMember[];
};

export async function getIntelligenceDashboard(
  churchId: string
): Promise<IntelligenceDashboard> {
  const response = await authenticatedFetch(
    `${API_BASE_URL}/intelligence/churches/${churchId}/dashboard`,
    {
      headers: getAuthHeaders(),
    }
  );

  if (!response.ok) {
    throw new Error("Failed to load intelligence dashboard");
  }

  return response.json();
}